import type { Rate } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'

/**
 * Модификатор оформления карточки.
 *
 * Статусы взаимоисключающие: берётся первый подходящий,
 * чтобы позитивный удалённый отзыв не красился сразу в два цвета.
 */
export default function getReviewCardClass(rate: Rate): string {
  if (rate.is_positive) {
    return 'lpu-review-card--positive'
  }

  if (rate.is_negative) {
    return 'lpu-review-card--negative'
  }

  if (rate.resolved) {
    return 'lpu-review-card--resolved'
  }

  if (rate.is_deleted) {
    return 'lpu-review-card--deleted'
  }

  if (rate.is_unconfirmed) {
    return 'lpu-review-card--unconfirmed'
  }

  return 'lpu-review-card--neutral'
}
